import styled from 'styled-components'
import Slider from 'react-slick'
import { List } from 'antd'

interface StyledProps {
  collapsed?: boolean
  secondary?: boolean
}

export const Arrow = styled.img`
  height: 48px !important;
  width: 35px !important;
  padding: 13px !important;
  text-align: center !important;
  border-radius: 10px;
  z-index: 1 !important;
  border: 0.2px solid rgba(220, 220, 220, 0.34) !important;
  background-color: #f9f9f9 !important;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.07) !important;
`

export const SliderStyledCollections = styled(Slider)`
  width: 100%;
  ${({ secondary }: StyledProps) => secondary ? `
    max-width: 886px;
    margin: 0 auto;
  ` : ''}

  .slick-slide .slick-active {
    width: 200px !important;
  }
`

export const StyledList = styled(List)`
  .ant-spin-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 10px;
  }

  .ant-list-item {
    border-bottom: none !important;
    flex: 0 0 24% !important;
  }

  @media (max-width: 767px) {
    .ant-spin-container {
      justify-content: center;
    }

    .ant-list-item {
      padding: 0;
    }
  }

  @media (min-width: 1024px) {
    .ant-spin-container {
      gap: 0;
    }

    .ant-list-item {
      flex: 0 0 20% !important;
    }
  }

  @media (min-width: 1440px) {
    padding-left: 60px;

    .ant-spin-container {
      gap: 30px;
    }

    .ant-list-item {
      flex: ${({ collapsed }: StyledProps) => (collapsed ? '0 0 17%' : '0 0 22%')} !important;
    }
  }

  @media (min-width: 1920px) {
    .ant-spin-container {
      gap: 0;
    }

    .ant-list-item {
      flex: ${({ collapsed }: StyledProps) => (collapsed ? '0 0 13%' : '0 0 20%')} !important;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ListRenderer/styledComponents.tsx